/**
 * MapLibre GL paint/layout expressions cannot read CSS custom properties —
 * they need literal color values baked in at layer-creation time. This is the
 * single, exported source of truth for those literals so map code never
 * hardcodes hex inline.
 *
 * Every value here must mirror a real semantic/base token from
 * `atlas-design-system/project/tokens/colors.css` (mirrored into
 * `packages/web/src/styles/colors.css`). If the design system's token value
 * ever changes, update it here too — see `README.md` in this directory.
 */
export const MAP_COLORS = {
  /** Mirrors --accent / --gold-500. Collected / completed features, gold trace. */
  gold: "#F4B740",
  /** Mirrors --status-info / --sky-400. In-progress features, region overlay. */
  sky: "#46B6E8",
  /** Mirrors --status-success / --spruce-400. Completed match sections/points (activity review). */
  spruce: "#37BE76",
  /** Mirrors --ink-400 (--text-faint). Not-collected / unvisited features. */
  grey: "#566777",
  /** Mirrors --map-explored. Explored-cells (fog of war) fill, spec 13. Warm ember,
   *  deliberately not Summit Gold (traces/collected) and not the sky in-progress hue. */
  explored: "#F0663A",
  /** Mirrors --text-on-gold (--ink-950). Label text drawn on a gold-filled shape (cluster counts). */
  textOnGold: "#090C10",
  /** Mirrors --text-primary (--ink-50). Label text drawn on a grey-filled shape (cluster counts). */
  textOnGrey: "#EAEFF3",
} as const;

export type MapColorName = keyof typeof MAP_COLORS;
